import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-check",
  "use": "icon-check-usage",
  "viewBox": "0 0 15 12",
  "content": "<symbol viewBox=\"0 0 15 12\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-check\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M14.2501 0.441069C14.5588 0.717264 14.5852 1.19141 14.309 1.5001L5.80896 11.0001C5.66237 11.1639 5.45128 11.2552 5.23151 11.2498C5.01174 11.2443 4.80541 11.1428 4.66709 10.9719L0.417091 5.7219C0.156469 5.39995 0.206181 4.92769 0.528126 4.66707C0.850072 4.40644 1.32234 4.45616 1.58296 4.7781L5.27859 9.34329L13.1911 0.499903C13.4673 0.191214 13.9414 0.164873 14.2501 0.441069Z\" fill=\"#8267db\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol